// sites.js
export const MKS_SITES = [
    "VAN",
    "NOG",
    "ROC-H",
    "BRM",
    "AUS",
    "BVT",
    "BOZ",
    "MIL",
    "LAW",
    "IRV",
    "2TDR",
    "LOG",
    "KFL",
    "HAV",
    "AND",
    "MET",
    "ROC-STP",
    "FRA",
    "ROC-LIN",
    "MACE",
    "WIL",
    "SHA (VSD)",
    "SHA (PSD (ESB))",
    "SHE",
    "WUX",
    "BEI",
    "TSIM",
    "CAR",
    "RHVT",
    "SAI",
    "TOK 1",
    "OSA",
    "AKI",
    "PLT 1",
    "YON",
    "SNG PSD (ESB)",
    "SNG (VSD)",
    "TAI (VSD)",
    "TAI PSD (ESB)",
    "HCMC MKS",
    "RAN",
    "BUC",
    "BOU",
    "BEA",
    "BER",
    "DAR",
    "STA",
    "MUN",
    "ITA",
    "CRE",
    "TOK 2",
    "PLT 2",
    "JER",
    "PLAN",
  ];
  
  export const MSD_SITES = [
    "BAAT",
    "TABO",
    "BURL",
    "QUAT 1",
    "SF",
    "ROCK",
    "PORT",
    "DETR",
    "NNJG & WUHA",
    "GUNG",
    "HUIZ",
    "CHNG",
    "DONG",
    "QING",
    "ZHON",
    "TIAN",
    "SNGA",
    "WENZ",
    "YANG",
    "ZHAO",
    "NINB",
    "XIAM",
    "KOWL",
    "BANG",
    "PUNE",
    "HARY",
    "TAMI",
    "LUDH",
    "MNSR",
    "GRGN",
    "MUMB",
    "AICH",
    "KANA",
    "JAHN",
    "ATKO",
    "PNNG",
    "KUAL",
    "MAKA",
    "SPOR & JAKA",
    "GUAN",
    "TPEI",
    "KAOH",
    "TAOY",
    "BKOK",
    "PTHU",
    "HCMC MSD",
    "HANO",
    "WANT",
    "MNSK",
    "SOF",
    "JABL",
    "OLAV",
    "WERD",
    "BRLN",
    "FEUC",
    "TREB",
    "BDAP",
    "LAIN",
    "VILN",
    "MERN",
    "POZN",
    "OIAP",
    "BUCA",
    "PODN",
    "ERND",
    "CERA",
    "NORK",
    "BASL",
    "ISBU",
    "WBRM",
    "QUAT 2",
  ];